import React from 'react';

import {
	StyledBackofficeFooter,
} from './style';

const BackofficeFooter = () => (
	<StyledBackofficeFooter>
		<p>© 1995-2019 Webmotors S.A. Todos direitos reservados.</p>
	</StyledBackofficeFooter>
);

export default BackofficeFooter;
